import mapKeys from 'lodash-es/mapKeys'

import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../../../../constants/validation'
import {
  getListingFlatPublishedListingTitle,
  getListingServerFieldErrors,
  LISTING_FLAT_ALREADY_PUBLISHED_ERROR_CODE,
  LISTING_FLAT_NOT_FOUND_ERROR_CODE,
  LISTING_FORM_FIELD_NAME_FLAT,
  LISTING_UNIT_LOCKED_ERROR_CODE,
} from '../../../../../../RentalPortalListing'

import { LISTING_PROFILE_BLOCK_SERVER_FIELD_NAME } from './useListingProfileBlockSave.constants'

export function getListingProfileBlockSaveErrors({ error, t }) {
  switch (error?.response?.data?.errors) {
    case LISTING_FLAT_ALREADY_PUBLISHED_ERROR_CODE:
      return {
        [LISTING_FORM_FIELD_NAME_FLAT]: t(
          'RentalPortal.ListingFormFlatHasPublishedErrorKey',
          {
            title: getListingFlatPublishedListingTitle({
              flatPublishedListing: error.response.data.meta?.listing,
              t,
            }),
          }
        ),
      }
    case LISTING_UNIT_LOCKED_ERROR_CODE:
      return {
        [LISTING_FORM_FIELD_NAME_FLAT]: t(
          'RentalPortal.ListingAddressDraftOnlyTooltipKey'
        ),
      }
    case LISTING_FLAT_NOT_FOUND_ERROR_CODE:
      return { [LISTING_FORM_FIELD_NAME_FLAT]: t('Error.IncorrectValueKey') }
    default:
      return {
        [SERVER_NON_FIELD_ERROR_KEY]: t('RentalPortal.ListingFormSaveErrorKey'),
        ...mapKeys(
          getListingServerFieldErrors({ error, t }),
          (message, field) =>
            LISTING_PROFILE_BLOCK_SERVER_FIELD_NAME[field] ?? field
        ),
      }
  }
}
